import React, { useContext } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material'
import { useSnackbar } from 'notistack'
import { useActivateUser, useDeactivateUser } from '../../api/user'
import { UserContext } from './UserTable'

export const UserActiveStatusDialog = (props) => {
  const { open, row, onClose } = props
  const deactivateUserApi = useDeactivateUser()
  const activateUserApi = useActivateUser()
  const { enqueueSnackbar } = useSnackbar()
  const { refetch } = useContext(UserContext)

  const handleCancel = () => {
    onClose()
  }

  const handleActivateUser = async () => {
    const res = await activateUserApi.mutateAsync({ userId: row._id }).catch((e) => {
      enqueueSnackbar('Failed to activate user', {
        variant: 'error',
      })
    })

    if (res?.status === 200) {
      enqueueSnackbar(`${row.email} is activated`, {
        variant: 'success',
      })
      refetch()
      onClose()
    }

    return res
  }

  const handleDeactivateUser = async () => {
    const res = await deactivateUserApi.mutateAsync({ userId: row._id }).catch((e) => {
      enqueueSnackbar('Failed to deactivate user', {
        variant: 'error',
      })
    })

    if (res?.status === 200) {
      enqueueSnackbar(`${row.email} is deactivated`, {
        variant: 'success',
      })
      refetch()
      onClose()
    }

    return res
  }

  return (
    <Dialog maxWidth='sm' open={open}>
      <DialogTitle id='edit-endDate-title'>Are you sure?</DialogTitle>
      <DialogContent dividers>
        {row.active ? (
          <Typography>
            Do you want to deactivate <b>{row.email}</b>?
          </Typography>
        ) : (
          <Typography>
            Do you want to activate <b>{row.email}</b>?
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' onClick={handleCancel}>
          Cancel
        </Button>
        <Button
          style={{ backgroundColor: 'black', color: 'white' }}
          onClick={row.active ? handleDeactivateUser : handleActivateUser}
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  )
}
